import React from 'react';
import { ModalButton } from '@components/main-components/modals/ModalButton';
import { StandardModal } from '@components/main-components/modals/StandardModal';
import { useSecondaryModal } from '@context/secondaryModal';

const UNAUTHENTICATED_COPY = `We were unable to authenticate your account because you may have locked or logged out of your wallet.`;

const RECONNECT__COPY = `Please sign in with your wallet to continue.`;

export function ReconnectWallet({ handleSignin }: { handleSignin: () => void }) {
  const { closeCancelModal } = useSecondaryModal();

  return (
    <StandardModal
      closeModal={closeCancelModal}
      title="Reconnect your wallet"
      bodyWithoutPaddingBottom
      body={
        <div className="flex flex-col gap-6">
          <p className="font-base text-base800">{UNAUTHENTICATED_COPY}</p>
          <p className="font-base text-base800">{RECONNECT__COPY}</p>
          <ModalButton label="Sign in" variant="primary" onClick={handleSignin} />
        </div>
      }
    />
  );
}
